import { render, staticRenderFns } from "./ErrorMsg.vue?vue&type=template&id=51222dfc&scoped=true"
import script from "./ErrorMsg.vue?vue&type=script&lang=js"
export * from "./ErrorMsg.vue?vue&type=script&lang=js"
import style0 from "./ErrorMsg.vue?vue&type=style&index=0&id=51222dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51222dfc",
  null
  
)

export default component.exports